module.exports = __webpack_public_path__ + "img/h07-min.fa14e9db.png";